var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Box } from '@ally/metronome-ui';
import { TextInput } from '../inputs';
export const VIN_HULL_ID_PATTERN = /^([a-zA-Z0-9]{12}|[a-zA-Z0-9]{14}|[a-zA-Z0-9]{17})$/;
export const defaultValidate = (value, required = false) => {
    // if the input is not required then an empty field should never show a validation error
    if (!required && !value) {
        return undefined;
    }
    if (!value) {
        return 'Enter VIN/Hull ID to continue.';
    }
    if (!VIN_HULL_ID_PATTERN.test(value)) {
        return 'Enter a valid 17-character VIN or a 12 or 14-character Hull ID.';
    }
    return undefined;
};
const VINHullId = (_a) => {
    var { className, label = 'VIN/Hull ID', name, required, validate } = _a, props = __rest(_a, ["className", "label", "name", "required", "validate"]);
    const fallback = (value) => defaultValidate(value, required);
    return (React.createElement(Box, { className: className },
        React.createElement(TextInput, Object.assign({ labelContent: label, inputType: "text", name: name, required: required, validate: validate || fallback }, props))));
};
export default VINHullId;
//# sourceMappingURL=VINHullId.js.map